import Model from './Model'

export default class CustomTrade extends Model {
  resource() {
    return 'custom-trades'
  }
}
